import $ from "jquery";

$(function () {
    document.documentElement.setAttribute("data-useragent", navigator.userAgent);

    if (window.jsLoadTimeout) {
        clearTimeout(window.jsLoadTimeout);
    }
    $("body").addClass("has-js").removeClass("no-js");

    $("body").on("click", ".js-toggle-dropdown", function () {
        $(this).closest(".faq-list__item").toggleClass("faq-list__item--active").find(".faq-list__body").stop().slideToggle();

        return false;
    });
});
